document.addEventListener('DOMContentLoaded', function() {
  const sampleProductsSwiper = new Swiper('.sample-products-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: "auto",
        spaceBetween: 12
      },
      480: {
        slidesPerView: "auto",
        spaceBetween: 16
      },
      768: {
        slidesPerView: "auto",
        spaceBetween: 20
      }
    }
  });
}); 